/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import msdyn365Commerce from '@msdyn365-commerce/core-internal';
import { ICheckoutApplePayViewProps } from '@msdyn365-commerce-modules/checkout/src/modules/checkout-apple-pay/checkout-apple-pay';
import { ICheckoutApplePayData } from '@msdyn365-commerce-modules/checkout/src/modules/checkout-apple-pay/checkout-apple-pay.data';
import { ICheckoutApplePayProps } from '../definition-extensions/checkout-apple-pay.ext.props.autogenerated';

const CheckoutApplyPayView: React.FC<ICheckoutApplePayViewProps & ICheckoutApplePayProps<ICheckoutApplePayData>> = (props) => {
    const { checkoutApplePay, applePayButton, alert } = props;
    const [applePayImage, setApplePayImage] = React.useState('');

    React.useEffect(() => {
        if (props.config.applePayImage) {
            setApplePayImage(`url('${props.config.applePayImage}')`);
        }
    }, [props.config.applePayImage]);

    if (msdyn365Commerce.isBrowser) {
        if (props.config.applePayImage) {
            document.documentElement.style.setProperty('--applePayImage', `${applePayImage}`);
            document.documentElement.style.setProperty('--applePayWebkit', `none`);
        } else {
            document.documentElement.style.setProperty('--applePayWebkit', `-apple-pay-button`);
        }
    }
    return (
        <Module {...checkoutApplePay}>
            {alert}
            {applePayButton}
        </Module>
    );
};

export default CheckoutApplyPayView;
